import React from "react";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import routes from "../constants/routes";
import { Typography, Card } from "@material-ui/core";
import TopBar from "../components/navigation/Header/TopBar";
import { Footer } from "../components";

const styles = (theme: Theme) =>
  createStyles({
    content: {
      alignItems: "center",
      display: "flex",
      flexGrow: 1,
      justifyContent: "center",
      marginBottom: theme.spacing(8),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(8),
      maxWidth: theme.breakpoints.width("md")
    },
    divider: {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(4)
    },
    link: {
      color: theme.palette.primary.main,
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    },
    linkWrapper: {
      marginBottom: theme.spacing(2)
    },
    root: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column"
    },
    subtitle: {
      marginBottom: theme.spacing(2)
    },
    termsList: {
      ...theme.typography.body2
    },
    termsWrapper: {
      padding: theme.spacing(4),
      paddingBottom: theme.spacing(8)
    },
    title: {
      marginBottom: theme.spacing(4)
    }
  });

type State = {};

type Props = {
  authenticated: boolean;
  classes?: any;
};

class TermsAndConditions extends React.Component<Props, State> {
  render() {
    const { authenticated, classes } = this.props;
    return (
      <div className={classes.root}>
        {!authenticated && <TopBar />}
        <div className={classes.content}>
          <Card className={classes.termsWrapper}>
            <Typography className={classes.title} color="primary" variant="h2">
              {routes.PRIVACY.label}
            </Typography>
            <section>
              <Typography>
                The following information is stored about your visit:
              </Typography>
              <ul className={classes.termsList}>
                <li>your IP address</li>
                <li>your username</li>
                <li>the date and time you visited the website</li>
                <li>your operating system</li>
                <li>the type of Web browser you use</li>
                <li>The web site also uses cookies during your session.</li>
              </ul>
              <Typography>
                We will hold your personal information in accordance with the
                Privacy Act 1993. The Privacy Act 1993 regulates us through the
                Information Privacy Principles as to how we collect, use, hold,
                disclose, access, correct, manage and dispose of your personal
                information.
              </Typography>
              <Typography>
                For more information visit the{" "}
                <a
                  className={classes.link}
                  href="https://www.privacy.org.nz/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Office of the Privacy Commissioner website
                </a>
                .
              </Typography>
            </section>
          </Card>
        </div>
        {!authenticated && (
          <Footer
            links={[
              { url: routes.HOME.url, label: "Home" },
              { url: routes.TERMS.url, label: routes.TERMS.label }
            ]}
          />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(TermsAndConditions);
